// variable 
const virutalCartButton = document.querySelector(".virtual-cart-button");
const bulkAddCartButton = document.querySelector(".main-product-button");
const stkCartBtn = document.querySelector('.virtual-sticky-add-to-cart')

/** ================================ bulk add js start ================================================ */
let cartButton;
let virtualCart;
let bulkAddForm;
let stickyCart;

console.log("loaddeeddd ==========================");

// console.log(limit, 'limit')
const allShades = document.querySelectorAll(".custom_input");
const finalShades = document.querySelectorAll(".selected_shade_box");
const crosses = document.querySelectorAll(".cross");
const mediaGallary = document.querySelector(".product__media-list");
const shadeLeft = document.querySelector(".shade-left");
// cartButton = document.querySelector(".shopify-payment-button__button");
cartButton = document.querySelector(".bulk-add-to-cart");
virtualCart = document.querySelector(".virtual-cart-button");
stickyCart = document.querySelector(".virtual-sticky-add-to-cart");
bulkAddForm = document.querySelector("#bulk-add-form");
const stickyCartWrapper = document.querySelector(".sticky-cart-wrapper");

//  listen on sticky cart button

if (stickyCartWrapper) {
  stickyCartWrapper.addEventListener("click", () => {
    if (stickyCart.disabled) {
      window.scrollTo({ top: 50, behavior: "smooth" });
    } else {
      return;
    }
  });
}

if (cartButton) {
  //some changes
  console.log(cartButton, "pointer events");
  // cartButton.style.pointerEvents =  "auto";
  // cartButton.style.visibility = "visible";
  cartButton.disabled = true;
  virtualCart.disabled = true;
  stickyCart.disabled = true;
}

let selectedShadesArray = [];

const showSelected = document.querySelector(".show-selected");

function updateImageOnSlider(shadeCode) {
  const mediaGallary = document.querySelector(".product__media-list");
  const images = mediaGallary.querySelectorAll("li");
  const findSelectedImage = mediaGallary.querySelector(
    `li[data-mediaalt="${shadeCode}"]`
    );
  const findActiveImage = mediaGallary.querySelector(".is-active");

  // console.log(shadeCode)

  if (findSelectedImage) {
    mediaGallary.scrollLeft = findSelectedImage.offsetLeft;
    findActiveImage.classList.remove("is-active");
    findSelectedImage.classList.add("is-active");
  }

  const findImageThumbnail = document.querySelector(`button[thumb-alt="${shadeCode}"]`)
  if(findImageThumbnail != null) { 
    findImageThumbnail.click()
  }
}

function updateActiveImage(code, lowres, hires) {
  let getAllLi = mediaGallary.querySelectorAll("li");
  let updateFirstLiImage = getAllLi[0].querySelector("img");
  let productSlider = document.querySelector(".product__media-list");

  productSlider.scrollLeft = 0;

  updateFirstLiImage.src = "";
  updateFirstLiImage.srcset = "";
  updateFirstLiImage.src = lowres;
  updateFirstLiImage.src = hires;
}

allShades.forEach((shade) => {
  shade.disabled = false;
});

// select one by default
// allShades[0].checked = true
// selectFiveShade(allShades[0])
allShades.forEach((shade) => {
  shade.addEventListener("click", (e) => {
    selectFiveShade(shade);
  });
});

// function one
function selectFiveShade(shade) {
  const shadeValue = {
    shade_name: shade.dataset.name,
    shade_id: shade.dataset.id,
    shade_image: shade.dataset.image,
    shade_code: shade.dataset.code,
    shade_hires: shade?.dataset?.hires,
  };

  const checkAlreadyContain = selectedShadesArray.some(
    (shade) => shade.shade_id === shadeValue.shade_id
  );
  const selectedIndex = selectedShadesArray.findIndex(
    (obj) => obj.shade_id === shade.dataset.id
  );

  if (!checkAlreadyContain && selectedShadesArray.length != limit) {
    selectedShadesArray.push(shadeValue);
    updateShowSelected();
    updateFinalShadesColor();
    // updateActiveImage(shadeValue.shade_code, shadeValue.shade_image, shadeValue.shade_hires)
    updateImageOnSlider(shadeValue.shade_code);
    const shadesToadd = selectedShadesArray.length - limit;
    shadeLeft.innerText = Math.abs(shadesToadd);
    // update name and value
    shade.name = `properties[${shadeValue.shade_name}]`;
    shade.value = shade.dataset.sku;

    if (selectedShadesArray.length === limit) {
      toggleInput(true);
      document.querySelector(".choose-shade-warning").style.display = "none";
    }
  } else {
    selectedShadesArray.splice(selectedIndex, 1);
    updateFinalShadesColor();
    updateShowSelected();
    toggleInput(false);
    document.querySelector(".choose-shade-warning").style.display = "inherit";

    const shadesToadd = selectedShadesArray.length - limit;
    shadeLeft.innerText = Math.abs(shadesToadd);

    // remove name and value
    shade.name = "";
    shade.value = "";
  }

  console.log(selectedShadesArray);
}

// function two disable & enables shades
function toggleInput(toggleValue) {
  allShades.forEach((shade) => {
    if (toggleValue) {
      if (!shade.checked) {
        shade.disabled = true;
        // cartButton.disabled = false;
        virtualCart.disabled = false;
        stickyCart.disabled = false;
        shade.parentElement.style.opacity = 0.5;
      }
    } else {
      shade.disabled = false;
    //   cartButton.disabled = true;
      virtualCart.disabled = true;
      stickyCart.disabled = true;
      shade.parentElement.style.opacity = 1;
    }
  });
}

// function three update final kit
function updateFinalShadesColor() {
  finalShades.forEach((shade, index) => {
    const shadeColor = selectedShadesArray[index]?.shade_image || null;
    const addDataList = shade.querySelector(".cross");
    if (!shadeColor) {
      shade.style.background = "white";
      shade.classList.remove("active");
    } else {
      shade.style.background = `${shadeColor}`;
      shade.style.background = `url('${selectedShadesArray[index]?.shade_image}')`;
      shade.classList.add("active");
      addDataList.dataset.key = selectedShadesArray[index]?.shade_id;
    }
  });
}

//  function crosses

crosses.forEach((cross) => {
  cross.addEventListener("click", () => {
    let removeThisShade;
    allShades.forEach((shade) => {
      if (shade.dataset.id == cross.dataset.key) {
        removeThisShade = shade;
      }
    });
    removeThisShade.checked = false;
    selectFiveShade(removeThisShade);
  });
});

// show selected
function updateShowSelected() {
  let selectedShadeString = " ";
  for (const shade of selectedShadesArray) {
    selectedShadeString += `${shade.shade_name}, `;
  }
  showSelected.innerText = selectedShadeString;
}


/** ================================ bulk add js end================================================ */


/**   GET  CART DATA START */
async function getCartData() {
    const cart = await fetch("/cart.js", {
      method: "GET",
    })
      .then((res) => {
        const response = res.json();
        return response;
      })
      .then((data) => {
        return data;
      });
  
    return cart.items;
  }
/**   GET  CART DATA END */





/** ================================ remove same item from cart Start================================================ */
//  removeSameItemFromCart

async function removeSameItem(itemKey) {
    let data = {
      id: itemKey,
      quantity: 0,
      sections: ["cart-drawer", "cart-icon-bubble"],
    };
  
    const removeSameItemFromCart = await fetch(`/cart/change.js`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        // Handle successful update
        if (response.ok) {
          bulkAddCartButton.click();
          setTimeout(() => {
            virutalCartButton.classList.remove("loading");
            stkCartBtn.classList.remove("loading");
          }, 1000);
        }
        console.log("Cart updated successfully!", response);
      })
      .catch((error) => {
        // Handle error
        console.error(error);
        virutalCartButton.classList.remove("loading");
        stkCartBtn.classList.remove("loading");
      });
    return removeSameItemFromCart;
  }

  
/** ================================ remove same item from cart End================================================ */
/** ================================ VIRTUAL CART BUTTON CLICK START================================================ */
// VIRTUAL CART BUTTON
async function virtualCartClick(productVariantId) {
    virutalCartButton.classList.add("loading");
    stkCartBtn.classList.add("loading");
    let isSameItemInCart = false;
    virutalCartButton.querySelector(".virtual-cart-text").innerText =
      "UPDATE YOUR SHADES";
    // stkCartBtn.querySelector(".virtual-cart-text").innerText = "UPDATE YOUR SHADES";
  
    const cartItems = await getCartData();
    cartItems.forEach((item) => {
      if (item.id === productVariantId) {
        const removeSameProductFromCart = removeSameItem(item.key);
        isSameItemInCart = true;
      }
    });
  
    if (!isSameItemInCart) {
      bulkAddCartButton.click();
      setTimeout(() => {
        virutalCartButton.classList.remove("loading");
        stkCartBtn.classList.remove("loading");
      }, 500);
    }
  }

  /** ================================ VIRTUAL CART BUTTON CLICK  END================================================ */


// cart upsell slider start
// cart slider
const cartUpsell = document.querySelector(".cart_upsell");
let cartUpsellPrevButton = document.querySelector(".cart-upsell-prev-button");
let cartUpsellNextButton = document.querySelector(".cart-upsell-next-button");
let cartUpsellSlider = document.querySelector(".cart_upsell_slider");

function cartUpsellScrollLeft() {
  let cartUpsellSlider = document.querySelector(".cart_upsell_slider");
  cartUpsellSlider.scrollLeft += cartUpsellSlider.scrollWidth / 2;
}

function cartUpseelScrollRight() {
  let cartUpsellSlider = document.querySelector(".cart_upsell_slider");
  cartUpsellSlider.scrollLeft -= cartUpsellSlider.scrollWidth / 2;
}

// cart upsell slider end


//  show virtual sticky cart button start
//  sticky cart show on page
let isBulkBuyButtonOnScreen = document.querySelector(".virtual-cart-button");
if (isBulkBuyButtonOnScreen) {
  document.addEventListener("scroll", () => {
    // console.dir(isBulkBuyButtonOnScreen.offsetTop)
    if (window.scrollY >= isBulkBuyButtonOnScreen.offsetTop * 2) {
      document.querySelector(".sticky-cart-wrapper ").classList.add("active");
    } else {
      document
        .querySelector(".sticky-cart-wrapper ")
        .classList.remove("active");
    }
  });
}



let normalStickyBtn = document.querySelector('.sticky-cart-wrapper.normal')
const productPage = document.querySelector('.product__info-wrapper')
let normalCartBtn = productPage.querySelector('.product-form__submit')

if(normalStickyBtn) { 

  let normalStickyCartButton = document.querySelector('.virtual-sticky-add-to-cart')

  normalStickyCartButton.addEventListener('click', () => { 
    normalCartBtn.click()
    normalStickyCartButton.classList.add('loading')
    setTimeout(() => {
      normalStickyCartButton.classList.remove('loading')
    }, 2000);
  })

  document.addEventListener("scroll", () => {
    // console.dir(isBulkBuyButtonOnScreen.offsetTop)
    if (window.scrollY >= 1000) {
      console.log(normalCartBtn.scrollHeight)
      normalStickyBtn.classList.add("active");
      // normalStickyBtn.style.display = 'block'
    } else {
      normalStickyBtn.classList.remove("active");
      // normalStickyBtn.style.display = 'none'
    }
  });


  

  

}

//  show virtual sticky  cart button end




// homepage slider update
function updateSlider(value) { 
  const clickedButton  = event.target
  let arrowBtn
  if(clickedButton.tagName != 'button') { 
    arrowBtn = clickedButton.closest('button')
  }else { 
    arrowBtn = clickedButton
  }
  
  const sliderParent = arrowBtn.closest('.custom-slider')
  const slider = sliderParent.querySelector('ul')
  
  if(value === 0 ) { 
   slider.scrollBy({ 
    left: -slider.clientWidth
   })
  }else { 
    slider.scrollBy({ 
      left: slider.clientWidth
     })
  }

}